import type { ReactNode } from "react";

import "./highlight.less";

/**
 * Splits `text` on query-token boundaries and wraps matched segments
 * in <mark class="search-highlight"> elements. Case-insensitive,
 * multi-token (splits query on whitespace). Returns the original
 * string unchanged if query is empty or has no matches.
 */
export function highlightMatches(text: string, query: string): ReactNode {
    if (!text || !query) return text;

    const tokens = query
        .trim()
        .split(/\s+/)
        .filter((t) => t.length > 0)
        .map(escapeRegExp);

    if (tokens.length === 0) return text;

    const pattern = new RegExp(`(${tokens.join("|")})`, "gi");
    const parts = text.split(pattern);

    if (parts.length === 1) return text;

    return parts.map((part, i) =>
        pattern.test(part) ? (
            <mark className="search-highlight" key={i}>
                {part}
            </mark>
        ) : (
            part
        ),
    );
}

function escapeRegExp(s: string): string {
    return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
